import GET_ARTICLES from "../class/getArticles";
import ScrollObserver from '../class/scrollObserver';
import Swiper, {Autoplay, EffectFade, Pagination} from "swiper";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

class transparentHeader extends ScrollObserver {
  constructor(elm=d.querySelector('.rwd002-header'),opt) {
    opt = Object.assign({
      rootMargin: "0% 0px 0%", // ビューポートの中心を判定基準にする
    }, opt);
    super(opt);
    this.header = elm;
    this.trigger = d.querySelector('.mainvisual');
    this.observeElement();
  }
  observeElement () {
    this.observer = new IntersectionObserver( this.callback.bind(this), this.opt);
    this.observer.observe( this.trigger );
  }
  intersectIn ( entry, object ) {
    this.header.classList.add('is-transparent');
  }
  intersectOut ( entry, object ) {
    this.header.classList.remove('is-transparent');
  }
}

const domReady = TPL => {
  if( mq.matches ) new transparentHeader();

  //メインスライダー
  new Swiper('.mainvisual [data-plugin="slider"]',{
    modules: [Autoplay, EffectFade, Pagination],
    loop: true,
    effect: 'fade',
    speed: 1200,
    fadeEffect: {
      crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
    },
    autoplay:{
      delay: 4500,
      disableOnInteraction: false,
      waitForTransition: false
    },
    pagination: {
      el: ".mainvisual-slider__pager",
      clickable: true,
    },
  });

  //NEWS
  const news_block = new GET_ARTICLES('.block-news__list[data-plugin="getArticles"]');
  news_block.makeItem = (item,content) => `
  <li class="block-${content}-item">
    <a href="/${content}/?mode=detail&amp;article=${item.id}" class="block-${content}-item__link">
      <div class="block-${content}-item__body">
        <div class="date-cate">
          <span class="date">${item.date}</span>
          <span class="cate">${item.category.name}</span>
        </div>
        <h4 class="title ${item.is_new? 'is-new':''}">${item.title.str_truncate(24)}</h4>
      </div>
    </a>
  </li>`;
  // news_block.makeItem = (item) => console.log(item);
  news_block.render();
};

const jqInit = () => false;

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}